import * as React from "react"
import { SxProps, Theme } from "@mui/material";
import TextField, { TextFieldProps }from '@mui/material/TextField';
import { BaseFormMode } from "../../hooks/useFormHooks";
import { CustomFormModeStylesMap, resolveFormModeStyle, formModeStyleToSx } from "../../styles/formStyling";

type FormTextFieldProps<TMode extends string = BaseFormMode> =
  TextFieldProps & {
    mode: TMode;
    modeStyles?: CustomFormModeStylesMap<TMode>;
  };

export function FormTextField<TMode extends string = BaseFormMode>({
  mode,
  modeStyles,
  sx,
  slotProps,
  disabled,
  ...rest
}: FormTextFieldProps<TMode>) {
  const resolvedStyle = resolveFormModeStyle(mode, modeStyles);

  // If disabled was explicitly passed (even as false), use it. Otherwise fall back to mode style.
  const resolvedDisabled =
    disabled !== undefined ? disabled : resolvedStyle.disabled;

  const resolvedReadOnly =
    slotProps?.htmlInput !== undefined && "readOnly" in slotProps.htmlInput
      ? (slotProps.htmlInput as React.InputHTMLAttributes<HTMLInputElement>)
          .readOnly
      : resolvedStyle.readOnly;

  return (
    <TextField
      {...rest}
      disabled={resolvedDisabled}
      sx={{ ...formModeStyleToSx(resolvedStyle), ...sx } as SxProps<Theme>}
      slotProps={{
        ...slotProps,
        htmlInput: {
          ...slotProps?.htmlInput,
          readOnly: resolvedReadOnly,
        },
      }}
    />
  );
}